/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type UserTypeFilter = typeof UserTypeFilter[keyof typeof UserTypeFilter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserTypeFilter = {
  Users: 'Users',
  Groups: 'Groups',
  UsersAndGroups: 'UsersAndGroups',
} as const;
